/**
 * API Types
 *
 * @package Enterprise\BookingSystem\Services
 */

export type ApiResponse<T> = {
	data: T;
	message?: string;
	success: boolean;
};

export type RequestConfig = {
	data?: Record<string, unknown>;
	headers?: Record<string, string>;
	method?: "DELETE" | "GET" | "PATCH" | "POST" | "PUT";
	parse?: boolean;
};

export class ApiError extends Error {
	constructor(
		message: string,
		public readonly code?: string,
		public readonly statusCode?: number,
		public readonly details?: unknown,
	) {
		super(message);
		this.name = "ApiError";
		Object.setPrototypeOf(this, ApiError.prototype);
	}
}
